export default {
  add: {
    required: ["name", "organisationalUnitReference"],
    type: "object",
    properties: {
      name: {
        type: "string",
        title: "Name",
      },
      organisationalUnitReference: {
        type: "string",
        title: "Organisational Unit Reference",
      },
    },
  },
  move: {
    required: ["newParentId"],
    type: "object",
    properties: {
      newParentId: {
        type: "number",
        title: "New Parent Id",
      },
    },
  },
  rename: {
    required: ["newName"],
    type: "object",
    properties: {
      newName: {
        type: "string",
        title: "New Name",
      },
    },
  },
};
